const ENUMS = {
  RESULT_PER_PAGE: ['36', '24', '12'],
  RESULT_PER_PAGE_DEFAULT: '24',
  MODE_GRID: 'GRID',
  MODE_LIST: 'LIST',
  SORTING_BY: 'bestsellers',
  SORTING_ORDER: 'desc',
}

export default ENUMS
